<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<a id="page_3"></a>
<h1 class="half">BRITAIN’S SECOND-HAND</h1>
<p class="half1"><span class="bold">TRAMS</span></p>
<div class="boxh">
<p class="aut">A<span class="small">N</span> H<span class="small">ISTORIC</span> O<span class="small">VERVIEW</span></p>
</div>
<p class="aut1">PETER WALLER</p>
<div class="image_container">
<img alt="images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?35a8f7ba